export const DigiProductCode = 'DIGI';
export const PtsProductCode = 'PTS';

export class UserEntitlements {
	public platformCode:string;
	public companyId: number;
	public productCode: string;
	public permissionNames: string[];
}

export interface UserAbilitiesRules {
    action: string | string[]; // Actions are CRUD, may come from redis or we may need to include at the client side
    subject: string | string[]; // uniquie permmission type name which is stored in redis cache
    conditions?: Record<PropertyKey, Object>; // this is to add abilities based on object props such as userId, UserRole, Product type etc
    fields?: string[]; // this is to define abilities per subject field (May be a future implementation)
    inverted?: boolean; // default is `false`
    reason?: string; // mainly to specify why user can't do something. See forbidden reasons for details
}

export class UserEntitlementCatalogValue {
    action: string;
    subject: string;
    participantId: number;
    productCode?: string;

    constructor(action: string, subject: string, productCode: string = DigiProductCode){
        this.action = action;
        this.subject = subject;
        this.productCode = productCode;
    }
}

export const UserEntitlementCatalogs = {
    ViewAssetsGlobalTab: new UserEntitlementCatalogValue('ViewAssetsGlobalTab', 'PermissionCheck'),

    LinkInvoices: new UserEntitlementCatalogValue('LinkInvoices', 'PermissionCheck'),

    ViewInBlockAnAssetButton: new UserEntitlementCatalogValue('ViewInBlockAnAssetButton', 'PermissionCheck'),

    ViewVaultInsurancePoliciesTab: new UserEntitlementCatalogValue('ViewVaultInsurancePoliciesTab', 'PermissionCheck'),
    ViewVaultInsurancePoliciesPage: new UserEntitlementCatalogValue('ViewVaultInsurancePoliciesPage', 'PermissionCheck'),
    ViewVaultInvoicesInvoiceTab: new UserEntitlementCatalogValue('ViewVaultInvoicesInvoiceTab', 'PermissionCheck'),
    EditVaultInvoicesPage: new UserEntitlementCatalogValue('EditVaultInvoicesPage', 'PermissionCheck'),
    ViewVaultRemittanceAdviceTab: new UserEntitlementCatalogValue('ViewVaultRemittanceAdviceTab', 'PermissionCheck'),
    EditVaultRemittanceAdvicesPage: new UserEntitlementCatalogValue('EditVaultRemittanceAdvicesPage', 'PermissionCheck'),
    ViewVaultInvoicesPage: new UserEntitlementCatalogValue('ViewVaultInvoicesPage', 'PermissionCheck'),
    ViewVaultPaymentTab: new UserEntitlementCatalogValue('ViewVaultPaymentTab', 'PermissionCheck'),
    ViewVaultCreditNotesTab : new UserEntitlementCatalogValue('ViewVaultCreditNotesTab', 'PermissionCheck'),
    ViewVaultUnappliedCashTab: new UserEntitlementCatalogValue('ViewVaultUnappliedCashTab', 'PermissionCheck'),

    DigitizeInvoices: new UserEntitlementCatalogValue('DigitizeInvoices', 'PermissionCheck'),
    DigitizeInsurancePolicies: new UserEntitlementCatalogValue('DigitizeInsurancePolicies', 'PermissionCheck'),
    DigitizePayments: new UserEntitlementCatalogValue('DigitizePayments', 'PermissionCheck'),
    DigitizeCreditNotes: new UserEntitlementCatalogValue('DigitizeCreditNotes', 'PermissionCheck'),
    DigitizeRemittanceAdvices: new UserEntitlementCatalogValue('DigitizeRemittanceAdvice', 'PermissionCheck'),
    DigitizeMultiAssetFiles: new UserEntitlementCatalogValue('DigitizeMultiAssetFile', 'PermissionCheck'),
    DigitizePurchaseOrders: new UserEntitlementCatalogValue('DigitizePurchaseOrders', 'PermissionCheck'),
    DigitizeUac: new UserEntitlementCatalogValue('DigitizeUac', 'PermissionCheck'),
    DigitizeCustomerData: new UserEntitlementCatalogValue('DigitizeCustomerData', 'PermissionCheck'),

    SendForApproval: new UserEntitlementCatalogValue('SendForApproval', 'PermissionCheck'),
    SendToSupplyChainFinance: new UserEntitlementCatalogValue('SendToSupplyChainFinance', 'PermissionCheck'),
    SendForReconciliation: new UserEntitlementCatalogValue('SendForReconciliation', 'PermissionCheck'),
    SendToAssetBackedFinance: new UserEntitlementCatalogValue('SendToAssetBackedFinance', 'PermissionCheck'),
    SendToPostTradeSettlement: new UserEntitlementCatalogValue('SendToPostTradeSettlement', 'PermissionCheck'),
    
    ViewImportJobTab: new UserEntitlementCatalogValue('ViewImportJobTab', 'PermissionCheck'),
    ViewImportJobPage: new UserEntitlementCatalogValue('ViewImportJobPage', 'PermissionCheck'),
    EditImportJobPage: new UserEntitlementCatalogValue('EditImportJobPage', 'PermissionCheck'),

    ViewConnectionsTab: new UserEntitlementCatalogValue('ViewConnectionsTab', 'PermissionCheck'),
    EditConnectionsPage: new UserEntitlementCatalogValue('EditConnectionsPage', 'PermissionCheck'),
    ViewCreateNewConnectionsButton: new UserEntitlementCatalogValue('ViewCreateNewConnectionsButton', 'PermissionCheck'),

    ViewImportModelTab: new UserEntitlementCatalogValue('ViewImportModelTab', 'PermissionCheck'),
    ViewImportModelPage: new UserEntitlementCatalogValue('ViewImportModelPage', 'PermissionCheck'),
    EditImportModelPage: new UserEntitlementCatalogValue('EditImportModelPage', 'PermissionCheck'),
    ViewCreateNewImportModelButton: new UserEntitlementCatalogValue('ViewCreateNewImportModelButton', 'PermissionCheck'),

    ViewManageSubscriptionsTab: new UserEntitlementCatalogValue('ViewManageSubscriptionsTab', 'PermissionCheck'),

    ManageTargetFacility: new UserEntitlementCatalogValue('ManageTargetFacility', 'PermissionCheck'),
    ManageTargetProgram: new UserEntitlementCatalogValue('ManageTargetProgram', 'PermissionCheck'),

    ViewValidationRuleTab: new UserEntitlementCatalogValue('ViewValidationRuleTab', 'PermissionCheck'),
    ViewCreateValidationRuleButton: new UserEntitlementCatalogValue('ViewCreateValidationRuleButton', 'PermissionCheck'),
    EditValidationRulePage: new UserEntitlementCatalogValue('EditValidationRulePage', 'PermissionCheck'),

    UnarchiveInvoice: new UserEntitlementCatalogValue('UnarchiveInvoice', 'PermissionCheck'),
    BulkDeleteInvoices: new UserEntitlementCatalogValue('BulkDeleteInvoices', 'PermissionCheck'),

    UpdateJobAssets: new UserEntitlementCatalogValue('UpdateJobAssets', 'PermissionCheck'),
    DeleteJobAssets: new UserEntitlementCatalogValue('DeleteJobAssets', 'PermissionCheck'),
    DigitizeJobAssets: new UserEntitlementCatalogValue('DigitizeJobAssets', 'PermissionCheck'),
    ModifyJobAssets: new UserEntitlementCatalogValue('ModifyJobAssets', 'PermissionCheck'),
    ReprocessJobAssets: new UserEntitlementCatalogValue('ReprocessJobAssets', 'PermissionCheck'),
    CloseJobAssets: new UserEntitlementCatalogValue('CloseJobAssets', 'PermissionCheck'),

    BankEntryView: new UserEntitlementCatalogValue('BankEntryView', 'PermissionCheck', PtsProductCode),
    BankEntryWrite: new UserEntitlementCatalogValue('BankEntryWrite', 'PermissionCheck', PtsProductCode),
    BankEntryConfirm: new UserEntitlementCatalogValue('BankEntryConfirm', 'PermissionCheck', PtsProductCode),
    ReverseInmatchPayment: new UserEntitlementCatalogValue('ReverseInMatchPayment', 'PermissionCheck', PtsProductCode),
    ApproveAndBookRecommendations: new UserEntitlementCatalogValue('ApproveAndBookRecommendations', 'PermissionCheck', PtsProductCode),

} as const;
